// if (!customElements.get("collection-feature")) {
//   customElements.define(
//     "collection-feature",
//     class CollectionFeature extends HTMLElement {
//       constructor() {
//         super();
//         // Bind the changeColors method to ensure the correct this context
//         this.changeColors = this.changeColors.bind(this);
//         this.resetColors = this.resetColors.bind(this);
//       }

//       connectedCallback() {
//         // Initialize component properties
//         this._initProperties();
//         // Attach event listeners
//         this._attachEventListeners();
//         // Preload background images
//         this._preloadHoverImages()
//       }

//       // Initialize component properties
//       _initProperties() {
//         this.sectionId = this.dataset.sectionId;
//         this.section = document.querySelector(
//           `[data-section-id="${this.sectionId}"]`,
//         );
//         if (!this.section) {
//           console.error("Section not found");
//           return;
//         }
//         this.items = this.section.querySelectorAll(".collection-feature__item");
//       }

//       // Attach event listeners to items
//       _attachEventListeners() {
//         this.items.forEach((item) =>
//           item.addEventListener("mouseover", () => this.changeColors(item)),
//         );
//         this.items.forEach((item) =>
//           item.addEventListener("mouseleave", this.resetColors),
//         );
//       }

//       // Preload images
//       _preloadHoverImages() {
//         this.items.forEach((item) => {
//           const bgImg = item.dataset.hoverBackgroundImage;
//           if (bgImg) {
//             const img = new Image();
//             img.src = bgImg;
//           }
//         });
//       }

//       // Handle color changes on mouseover
//       changeColors(item) {
//         const color = item.dataset.hoverColor;
//         const background = item.dataset.hoverBackground;
//         const backgroundImage = item.dataset.hoverBackgroundImage;

//         this.section.style.color = color || "";
//         this.section.style.background = background || "";
//         this.section.style.backgroundImage = backgroundImage ? `url("${backgroundImage}")`: "";
//         this.section.style.backgroundRepeat = 'no-repeat';
//         this.section.style.backgroundSize = 'cover';
//       }

//       resetColors() {
//         this.section.style.color = "";
//         this.section.style.background = "";
//       }

//       disconnectedCallback() {
//         // Properly remove event listeners
//         this.items.forEach((item) => {
//           item.removeEventListener("mouseover", this.changeColors);
//           item.removeEventListener("mouseleave", this.resetColors);
//         });
//       }
//     },
//   );
// }

if (!customElements.get("collection-feature")) {
  customElements.define(
    "collection-feature",
    class CollectionFeature extends HTMLElement {
      constructor() {
        super();
        // Bind the changeColors method to ensure the correct this context
        this.changeColors = this.changeColors.bind(this);
        this.resetColors = this.resetColors.bind(this);
      }

      connectedCallback() {
        // Initialize component properties
        this._initProperties();
        // Attach event listeners
        this._attachEventListeners();
        // Preload background images
        this._preloadHoverImages()
      }

      // Initialize component properties
      _initProperties() {
        this.sectionId = this.dataset.sectionId;
        this.section = document.querySelector(
          `[data-section-id="${this.sectionId}"]`,
        );
        if (!this.section) {
          console.error("Section not found");
          return;
        }
        this.items = this.section.querySelectorAll(".collection-feature__item");
        this.items.forEach((item) => {
          console.log(item);
          console.log(item.dataset)
          const color = item.dataset.hoverColor;
          const backgroundColor = item.dataset.hoverBackground;
          const backgroundImage = item.dataset.hoverBackgroundImage;
          console.log(`${item.dataset.blockId}`);
          const background = document.getElementById(`${item.dataset.blockId}`);
          background.style.color = color || "";
          background.style.background = backgroundColor || "";
          background.style.backgroundImage = backgroundImage ? `url("${backgroundImage}")`: "";
          background.style.backgroundRepeat = 'no-repeat';
          background.style.backgroundSize = 'cover';
        }
        );
      }

      // Attach event listeners to items
      _attachEventListeners() {
        this.items.forEach((item) =>
          item.addEventListener("mouseover", () => this.changeColors(item)),
        );
        this.items.forEach((item) =>
          item.addEventListener("mouseleave", () => this.resetColors(item)),
        );
      }

      // Preload images
      _preloadHoverImages() {
        this.items.forEach((item) => {
          const bgImg = item.dataset.hoverBackgroundImage;
          if (bgImg) {
            const img = new Image();
            img.src = bgImg;
          }
        });
      }

      // Handle color changes on mouseover
      changeColors(item) {
        console.log(`${item.dataset.blockId}`);
        document.querySelector(`#${item.dataset.blockId}`).classList.add('active');
      }

      resetColors(item) {
        console.log("zeszło");
        console.log(`${item.dataset.blockId}`);
        document.querySelector(`#${item.dataset.blockId}`).classList.remove('active');
      }

      disconnectedCallback() {
        // Properly remove event listeners
        this.items.forEach((item) => {
          item.removeEventListener("mouseover", this.changeColors);
          item.removeEventListener("mouseleave", this.resetColors);
        });
      }
    },
  );
}
